import "ammap3";
import "../shared/israelPalestineLow";
import "../shared/light";

export function makeMap() {
	let map = AmCharts.makeChart("chartdiv", {
		"type": "map",
		"theme": "light",
		"zoomControl": {
			"zoomControlEnabled": false
		},
		"dragMap": false,
		"dataProvider": {
			"map": "israelPalestineLow",
			"zoomLevel": 1.4,
			"zoomLongitude": 35,
			"zoomLatitude": 31.9,
			"selectable": false,
			"areas": [
				//gaza
				{
					"id": "PS-RFH",
					"url": "/destinations/gaza/",
					"color": "#e85430",
				},
				{
					"id": "PS-KYS",
					"url": "/destinations/gaza/",
					"color": "#e85430",
				},
				{
					"id": "PS-DEB",
					"url": "/destinations/gaza/",
					"color": "#e85430",
				},
				{
					"id": "PS-GZA",
					"url": "/destinations/gaza/",
					"color": "#e85430",
				},
				{
					"id": "PS-NGZ",
					"url": "/destinations/gaza/",
					"color": "#e85430",
				},
				//west bank
				{
					"id": "PS-HBN",
					"url": "/destinations/hebron/"
				},
				{
					"id": "PS-BTH",
					"url": "/destinations/bethlehem/"
				},
				{
					"id": "PS-JEM",
					"url": "/destinations/jerusalem/"
				},
				{
					"id": "PS-JRH",
					"url": "/destinations/jericho/"
				},
				{
					"id": "PS-RBH",
					"url": "/destinations/ramallah-al-bireh/"
				},
				{
					"id": "PS-SLT",
					"url": "/destinations/salfit/"
				},
				{
					"id": "PS-NBS",
					"url": "/destinations/nablus/"
				},
				{
					"id": "PS-JEN",
					"url": "/destinations/jenin/"
				},
				{
					"id": "PS-TBS",
					"url": "/destinations/tubas/"
				},
				{
					"id": "PS-QQA",
					"url": "/destinations/qalqilya/"
				},
				{
					"id": "PS-TKM",
					"title": "Tulkarem",
					"url": "/destinations/tulkarem/"
				}
			],
			// "images": [
			// 	{
			// 		"latitude": 31.301276,
			// 		"longitude": 34.280106,
			// 		"label": "Rafah",
			// 		"labelBackgroundColor": "#FFFFFF",
			// 		"labelBackgroundAlpha": .6,
			// 		"labelFontSize": "13",
			// 		"labelPosition": "right",
			// 		"labelShiftX": 15
			// 	},
			// 	{
			// 		"latitude": 31.357550,
			// 		"longitude": 34.285739,
			// 		"label": "Yunis",
			// 		"labelBackgroundColor": "#FFFFFF",
			// 		"labelBackgroundAlpha": .6,
			// 		"labelFontSize": "13",
			// 		"labelPosition": "left",
			// 		"labelShiftX": -15
			// 	}
			// ]
		},
		"areasSettings": {
			"autoZoom": false,
			"color": "#57803d",
			"colorSolid": "#dcdcdc",
			"selectedColor": "#6d9f49",
			"outlineColor": "#292929",
			"rollOverColor": "#6d9f49",
			"unlistedAreasColor": "#e2e2e2",
			"urlTarget": "_blank",
			"alpha": 0.8,
			"unlistedAreasAlpha": .3
		},
		"legend": {
			"width": "100%",
			"marginRight": 27,
			"marginLeft": 27,
			"equalWidths": false,
			"backgroundAlpha": 0.5,
			"backgroundColor": "black",
			"borderColor": "grey",
			"borderAlpha": 1,
			"bottom": 30,
			"left": 0,
			"horizontalGap": 10,
			"color": "#FFF",
			"data": [
				{
					"title": "Gaza",
					"color": "#e85430",
				},
				{
					"title": "West Bank",
					"color": "#57803d"
				}
			]
		},
	});
}


// WEBPACK FOOTER //
// ./src/home/map.js